/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import axios from "axios";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import FormControl from "@mui/material/FormControl";
import MDBackdrop from "components/MDBackdrop";
import { useSnackbar } from "notistack";
import CloseIcon from "@mui/icons-material/Close";
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import IconButton from "@mui/material/IconButton";
import Completion from "./Completion";
import { allowOnlyAlphanumericAndSpace } from "utils/Constant";
import { getDecodedUserData } from "utils/Constant";

function PopReset(props) {
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;

  const [isDisabled, setIsDisabled] = useState(false);

  const [vehicles, setVehicles] = useState([]);
  const [isBackdrop] = useState(false);
  const { onClose } = props;
  const [errors, setErrors] = useState({});

  const CHARGER_ID_MAX_LENGTH = 20;
  const CHARGER_ID_REGEX = /^[a-zA-Z0-9 ]+$/;

  const validateChargerId = (value) => {
    if (!value || !value.trim()) {
      return "Charger ID is required";
    }

    if (value.length > CHARGER_ID_MAX_LENGTH) {
      return `Maximum ${CHARGER_ID_MAX_LENGTH} characters allowed`;
    }

    if (!CHARGER_ID_REGEX.test(value)) {
      return "Invalid Charger ID";
    }

    return "";
  };

  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = (event) => {
    event.preventDefault();

    const chargerIdError = validateChargerId(values.charger_id);

    //  STOP HERE if invalid
    if (chargerIdError) {
      setErrors({
        charger_id: chargerIdError,
      });

      enqueueSnackbar(chargerIdError, { variant: "error" });
      return; //  prevents API call
    }

    if (!values.type || !values.reason) {
      enqueueSnackbar("Please Fill All The Details !!!", {
        variant: "error",
      });
      return;
    }

    createUser(values.type, values.charger_id.trim(), values.reason);
  };

  const createUser = (type, charger_id, reason) => {
    const payload = {
      chargerId: charger_id,
      type: type,
      resetReason: reason,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_BASEURL + "session/reset",
      data: payload,
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.status) {
          enqueueSnackbar(response.data.message, { variant: "success" });

          window.location.reload();
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
        }
      })
      .catch((error) => {
        enqueueSnackbar("An error occurred while reseting the charger.", {
          variant: "error",
        });
      });
  };

  const [values, setValues] = useState({
    charger_id: props.value?.charger_id || "",
    type: props.value?.type || "",
    reason: props.value?.reason || "",
  });
  const handleChange = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  const handleClose = () => {
    onClose(false);
  };

  const getAllVehiclesOfUser = useCallback(() => {
    axios({
      method: "get",
      url: process.env.REACT_APP_BASEURL + `users/user/${values.tag_id}/vehicles`,
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.success === true) {
          setVehicles(response.data.data);
        } else {
          setVehicles([]);
        }
      })
      .catch(() => {
        setVehicles([]);
      });
  }, [values.tag_id]);

  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }
    if (values.tag_id) {
      getAllVehiclesOfUser();
    } else {
      setVehicles([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.tag_id]);

  return (
    <>
      <Completion
        isDialog={isDisabled}
        onClose={setIsDisabled}
        value={values}
      />
      <MDBackdrop isBackdrop={isBackdrop} />
      <Dialog
        open={props.isDialog}
        onClose={handleClose}
        fullWidth={false} //  stop stretching
        PaperProps={{
          sx: {
            width: 1000, //  exact width (adjust if needed)
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle
          style={
            darkMode
              ? {
                  backgroundColor: "#202940",
                  color: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }
              : {
                  theme,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }
          }
        >
          Reset Charger
          <IconButton
            aria-label="delete"
            onClick={handleClose}
            style={darkMode ? { color: "#ffffff" } : theme}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          style={
            darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme
          }
        >
          <MDBox pt={0} pb={0} px={3}>
            <MDBox pt={0}></MDBox>
            <MDBox p={2} component="form" role="form">
              <MDBox p={1}>
                {/* <MDInput
                  type="text"
                  label="Charger name / ID"
                  value={values.charger_id}
                  name="charger_id"
                  margin="dense"
                  fullWidth={true}
                  onChange={handleChange}
                /> */}
                <MDInput
                  type="text"
                  label="Charger name / ID"
                  name="charger_id"
                  value={values.charger_id}
                  margin="dense"
                  fullWidth
                  inputProps={{ maxLength: CHARGER_ID_MAX_LENGTH }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValues((prev) => ({ ...prev, charger_id: value }));

                    setErrors((prev) => ({
                      ...prev,
                      charger_id: validateChargerId(value),
                    }));
                  }}
                  onBlur={(e) => {
                    const value = e.target.value;
                    setErrors((prev) => ({
                      ...prev,
                      charger_id: validateChargerId(value),
                    }));
                  }}
                  error={Boolean(errors.charger_id)}
                  helperText={errors.charger_id}
                  FormHelperTextProps={{
                    sx: {
                      color: "#d32f2f",
                      fontSize: "12px",
                      marginLeft: "4px",
                    },
                  }}
                />
              </MDBox>
              <MDBox p={1}>
                <FormControl fullWidth>
                  <InputLabel id="demo-multiple-name-label">Type</InputLabel>
                  <Select
                    showSearch
                    sx={{
                      height: 50,

                      "& .MuiSelect-icon": {
                        display: "block",
                        visibility: "visible",
                        opacity: 1,
                        color: "#6b6b6b",
                        right: 12,
                      },

                      "& .MuiOutlinedInput-input": {
                        paddingRight: "40px", // space for arrow
                      },
                    }}
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    placeholder="Select Type"
                    value={values.type}
                    name="type"
                    onChange={handleChange}
                    input={<OutlinedInput label="Type" />}
                    IconComponent={ArrowDropDownIcon}
                  >
                    <MenuItem value="Soft">Soft</MenuItem>
                    <MenuItem value="Hard">Hard</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox p={1}>
                <MDInput
                  type="text"
                  label="Reset reason"
                  value={values.reason}
                  name="reason"
                  multiline
                  rows={5}
                  placeholder="Enter Reason for the Reset of Charger.. "
                  margin="dense"
                  fullWidth={true}
                  onChange={handleChange}
                />
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions
          style={
            darkMode
              ? {
                  backgroundColor: "#202940",
                  justifyContent: "space-evenly",
                  color: "#ffffff",
                }
              : { theme, justifyContent: "space-evenly" }
          }
        >
          <MDButton
            style={{ width: "87%", maxWidth: 320 }}
            variant="gradient"
            color={sidenavColor}
            onClick={handleSubmit}
          >
            RESET
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default PopReset;
